import React, { useEffect } from "react";
import { GetAuth } from "../../contexts/AuthProvider";
import { GetSealStatus } from "../../contexts/SealProvider";
import StartPod from "./StartPod";
import Login from "./Login";
import Home from "./Home";
import SessionTimeoutModal from "../SessionTimeoutModal/SessionTimeoutModal";
import { Box, Loader, Typography } from "@saviynt/design-system";
import SavContainer from "../common/SavContainer/SavContainer";
import image from "../../assets/images/vbg-login.jpg";

function MainView() {
  const auth = GetAuth();
  const ctx = GetSealStatus();
  const status = ctx.state ? ctx.state.status : null;

  // Clear stale auth when pod is gone — useEffect avoids state-update-during-render
  useEffect(() => {
    if (status === "NotFound" && auth.token) {
      auth.logOut();
    }
  }, [status, auth.token]); // eslint-disable-line react-hooks/exhaustive-deps

  // Still loading initial status
  if (!ctx.state) {
    return (
      <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Loader kind="dots" format="inline" color="info" size="medium" />
      </Box>
    );
  }

  // NotFound — show start screen (logOut handled by useEffect above)
  if (status === "NotFound") {
    return <StartPod />;
  }

  // Running + valid JWT → secrets
  if (status === "Running" && auth.token) {
    return (
      <>
        <SessionTimeoutModal />
        <Home />
      </>
    );
  }

  // Running, no JWT → login (3 custodians sequentially)
  if (status === "Running") {
    return <Login />;
  }

  // Starting → waiting for pod to be ready
  if (status === "Starting") {
    return (
      <SavContainer>
        <img src={image} alt="vbg-start" />
        <Box style={{
          flex: 1,
          padding: "3rem",
          background: "var(--color-page-subtle, #f2f4f8)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1.5rem",
        }}>
          <Loader kind="dots" format="inline" color="info" size="medium" />
          <Typography kind="h2">Application is starting...</Typography>
          <Typography kind="body">Please wait while the application becomes ready.</Typography>
        </Box>
      </SavContainer>
    );
  }

  // NotFound → start screen
  return <StartPod />;
}

export default MainView;
